/**
 * Created by 赵耀 on 2023/3/28
 * Desc: 毕业影像首页
 */

import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { switchCurrentUser, switchUser } from "../../../redux/actions/userInfo";
import Swiper from 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.min.css'
import { Avatar, Carousel } from 'antd'
import { Toast, Modal } from 'antd-mobile'
import { connect } from "react-redux";
import { getIntValue, getSearchParams, getStrValue, isObjEmpty } from "../../../utils/common";
import './AlbumPreview.css'
import { fetchGet, fetchPost, fetchPostObj } from "../../../utils/fetchRequest";
import { _baseURL, API } from "../../../configs/api.config";
import ImagesViewer from '../../../components/imagesVIewer/index'
import phone_img from '../../../style/imgs/phone_icon.png';

class AlbumPreview extends Component {

    constructor() {
        super()

        this.state = {
            schoolId: 0,
            clazzId: 0,
            picExplain: null,
            consultPhone: null,
            albums: [],
            rulesList: [],
            buyType: 2,
            paidRules: 1,
            previewVisible: false,
            previewImage: '',
            description: ''
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

        document.title = "毕业影像";
        this.searchParams = getSearchParams(this.props.location.search)

        this.getHomeData()
    }

    componentWillUnmount() {

    }

    render() {
        let { albums, picExplain, consultPhone, previewVisible, buyType, paidRules, rulesList } = this.state

        const albumItems = []
        let pictureUrls = []
        if (!isObjEmpty(albums)) {
            albums.forEach((item, index) => {
                const pictureUrl = item.albumUrl
                pictureUrls.push(pictureUrl)
                albumItems.push(<div className="contentStyle" key={index}><img src={pictureUrl} onClick={this.handlePreview.bind(this, pictureUrl, index)} width={'100%'} height={160} style={{ borderRadius: '10px' }} /></div>)
            })
        }
        const rulesItems = []
        if (paidRules === 2) {
            rulesList.forEach((rechargeObj, index) => {
                rulesItems.push(
                    <div
                        className="span-btn" style={{ margin: '30px', white: 'white', }}
                        onClick={this.onNextClick.bind(this, index,
                            rechargeObj.id)} key={index}>
                        <span
                            className='service-content-item-text'>{rechargeObj.title}</span>
                        <span
                            className='service-content-item-text'></span>
                    </div>
                )
            })
        }


        return (
            <div className='album-page-root'>
                <div className='head-album-page'>
                    <MenuGroup groupIcon={require('imgs/ic_group_album.png')} groupText='毕业季一时光影像' />
                    <div className='head-word-page1'>
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                            <div dangerouslySetInnerHTML={{ __html: picExplain }} />
                        </div>
                    </div>
                </div>

                {/*班级相册*/}
                {<div className={isObjEmpty(albumItems) ? 'displayNone' : 'tail-album-page'}>
                    <MenuGroup groupIcon={require('imgs/ic_group_album.png')} groupText='班级相册' />
                    <div className="album-swiper-container">
                        <Carousel autoplay>
                            {albumItems}
                        </Carousel>
                    </div>

                    {previewVisible ?
                        <ImagesViewer onClose={this.handleCancel} urls={pictureUrls}
                            index={this.state.previewIndex}
                            needPoint={pictureUrls.length <= 9} /> : ""}

                    <div>
                        <div style={{ textAlign: 'center', margin: '5px 10px 5px 10px', color: 'white' }}>{buyType == 2 ? '订制后，相册将统一邮寄学校发放' : '订制后，相册将按详细地址邮寄'}</div>
                        <div style={{ textAlign: 'center' }}>
                            {paidRules === 1 ?
                                <span className="span-btn" style={{ margin: '30px', white: 'white' }}
                                    onClick={this.onNextClick}>我要定制</span> :
                                rulesItems
                            }
                        </div>
                        <div style={{ textAlign: 'center', margin: '5px 10px 5px 10px', color: 'white' }}>详情请咨询：
                            <a href={'tel:' + consultPhone} >
                                <div style={{ alignItems: 'center', color: '#000' }}>{consultPhone}<img style={{ height: 14, marginLeft: 10 }} src={phone_img} alt="" /></div>
                            </a>
                            <a href={'tel:' + 15388765510} >
                                <div style={{ alignItems: 'center', color: '#000' }}>{15388765510}<img style={{ height: 14, marginLeft: 10 }} src={phone_img} alt="" /></div>
                            </a>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }

    handlePreview = (url, index) => {
        this.setState({
            previewImage: url,
            previewVisible: true,
            previewIndex: index
        });
    }

    handleCancel = () => this.setState({ previewVisible: false })

    onNextClick = (index, ruleId) => {
        if(ruleId === undefined){
            ruleId = 0
        }
        let clazzId = this.searchParams.clazzId;
        let schoolId = this.searchParams.schoolId;
        let appId = this.searchParams.appId;
        let openId = this.searchParams.openId;
        this.props.history.push('/previewApply/' + schoolId + '/' + clazzId + '/' + appId + '/' + openId + '/' + ruleId);
    }

    getHomeData = () => {

        let albums = []

        // 获取班级相册接口
        fetchPost(API.ALBUM_PICTURE_LIST, {
            clazzId: this.searchParams.clazzId,
            schoolId: this.searchParams.schoolId
        }).then((response) => {
            Toast.hide();
            if (response && response.data) {
                const picAlbum = response.data.picAlbum
                const rulesList = response.data.rulesList
                const picExplain = response.data.picExplain
                const consultPhone = response.data.consultPhone
                const buyType = response.data.buyType
                const paidRules = response.data.paidRules
                console.log('picAlbum', picAlbum)

                picAlbum.forEach((hrObj, index) => {
                    if (hrObj) {
                        albums.push({
                            albumUrl: getStrValue(hrObj, 'picUrl'),
                        })
                    }
                });
                this.setState({
                    picExplain: picExplain,
                    consultPhone: consultPhone,
                    albums: albums,
                    buyType: buyType,
                    paidRules: paidRules,
                    rulesList: rulesList
                })

                console.log('albums', albums)
            }
        }).catch((error) => {
            Toast.hide();
            if (typeof error === 'string') {
                //Toast.fail(error, 2)
                if (error === '学校已停止订购') {
                    this.props.history.push('/previewPage/10')
                } else {
                    this.props.history.push('/previewPage/0')
                }
            } else {
                Toast.fail('数据加载失败', 2)
            }
        })
    }

}

class MenuGroup extends Component {
    render() {
        return (
            <div className='album-group-item-layout'>
                {/*<img className='home-group-item-icon' src={this.props.groupIcon}/>*/}
                <span className='album-group-item-text'>{this.props.groupText}</span>
            </div>
        )
    }
}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo }
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AlbumPreview)
